import React, {useEffect, useState} from "react";
import {ModalNames} from "../../../Constants/modalNames";
import {useModal} from "../../../Store/modules/modal/modal";
import {useLanguage} from "../../../Store/modules/language";
import {Div, HasLoading, Icon, Select, Text} from "../../Kit";
import {Button} from "../../Kit/Button";
import {useTheme} from "../../../Store/modules/theme";
import {Add} from "iconsax-react";
import settings from "../../../settings/settings";

import {Modal} from "../Modal/Modal";
import {separate} from "../../../Utils";
import {useGetExtraTokenShow} from "../../../Store/modules/ai/getExtraTokenShow/getExtraTokenShow";
import {useForm} from "react-hook-form";
import {usePostExtraTokenShow} from "../../../Store/modules/ai/postExtraTokenShow/postExtraTokenShow";
import {Trans} from "react-i18next";
import {useGetProfile} from "../../../Store/modules/ai/getProfile/getProfile";
import {ToggleSwitch} from "../ToggleSwitch/ToggleSwitch";
import {PuffLoader} from "react-spinners";

export const BuyExtraTokensModal: React.FC = () => {
    const {direction} = useLanguage();
    const {dispatchCloseModal, name} = useModal();
    const {name: themeStatus} = useTheme();
    let {getExtraTokenShowData, dispatchGetExtraTokenShow, getExtraTokenShowLoading} = useGetExtraTokenShow();
    let {postExtraTokenShowLoading, dispatchPostExtraTokenShow} = usePostExtraTokenShow();
    const [useWallet, setUseWallet] = useState<boolean>(false);
    const {getProfileData} = useGetProfile();
    let {data} = getProfileData || {};

    let {data: tokens} = getExtraTokenShowData || {};

    const {
        control,
        watch: watchData,
    } = useForm<{
        token: { label: string; value: string | number; currency: number };
    }>();

    const buyToken = () => {
        if (watchData().token) {
            let {label, currency} = watchData().token;
            dispatchPostExtraTokenShow({
                tokens_num: Number(label.replace(/[,.\s]/g, "")),
                currency_id: currency,
                use_wallet: isNeg ? true : useWallet
            });
        }
    }

    useEffect(() => {
        if (name === ModalNames.BuyExtraTokensModal) {
            dispatchGetExtraTokenShow()
        }
    }, [name]);

    const tokenValue = Number(watchData()?.token?.value) || 0;
    const walletBalance = Number(data?.balance) || 0;

    const finalPayment = useWallet
        ? Math.max(tokenValue - walletBalance, 0)
        : tokenValue;

    const nb = Number(walletBalance);
    const isNeg = !Number.isNaN(nb) && nb < 0;

    return (
        <Modal
            modalName={ModalNames.BuyExtraTokensModal}
            containerClassName={`overflow-y-visible ${getExtraTokenShowLoading ? "flex items-center" : ""}`}
            ignorePadding="w-full py-[15px] px-[20px]"
            modalClassName="rounded-[10px] relative w-[327px] flex flex-col justify-between items-center !overflow-visible"
        >
            <HasLoading LoadingComponent={PuffLoader} loading={getExtraTokenShowLoading}>
                <Div
                    dir={direction}
                    bg="forthOpt"
                    className="w-[27px] h-[27px] flex items-center justify-center pointer rounded-[50%] absolute right-[10px] top-[10px] "
                    onClick={() => dispatchCloseModal()}
                >
                    <Icon
                        Component={Add}
                        size={20}
                        className="rotate-[45deg]"
                        color="text"
                    />
                </Div>
                <div dir={direction} className="flex justify-center pt-[10px]">
                    <img src={settings.logo?.[themeStatus]} alt="logo" className="w-[60px]"/>
                </div>
                <div className="py-5 text-center">
                    <Text elementType="span" fontSize={18}
                          className="text-sm">profile.buyExtraTokensModal.chooseYourToken</Text>
                </div>
                <Div
                    className="rounded-[3px] min-w-[200px] flex items-center"
                    borderWidth="1px"
                    borderColor="primaryLight"
                    borderStyle="solid"
                    bg="transparent"
                >
                    <Div className="h-[42px] w-full text-start">
                        <Select control={control} name="token" options={tokens?.map((token) => ({
                            label: separate(token.tokens_num),
                            value: token.price,
                            currency: token.currency
                        })) || []}/>
                    </Div>
                </Div>
                {
                    watchData()?.token?.value ?
                        <>
                            <div className="flex justify-between mt-6">
                                <Text elementType="span" fontSize={14}>tokenCost</Text>
                                <div>
                                    <Text elementType="span" translatable={false}
                                          fontSize={13}>{separate(watchData()?.token?.value)}</Text>
                                    <Text elementType="span" className="ms-1" fontSize={12}>toman</Text>
                                </div>
                            </div>
                            <div className="flex justify-between items-center mt-4">
                                <Text elementType="span" translatable={false} fontSize={13}>
                                    <Trans
                                        i18nKey="walletBalance"
                                        values={{
                                            amount: Number(Math.floor(Number(data?.balance ?? 0))).toLocaleString("en-US"),
                                        }}
                                        components={{
                                            Text: <Text elementType="span" color={isNeg ? "error" : "success"}/>,
                                        }}
                                    />
                                </Text>
                                <ToggleSwitch
                                    label=""
                                    description=""
                                    checked={useWallet || isNeg}
                                    onChange={() => {
                                        if (!isNeg) {
                                            setUseWallet(!useWallet);
                                        }
                                    }}
                                />
                            </div>
                            <Div border className="mt-6"/>
                            <div className="flex justify-between items-center mt-5">
                                <Text elementType="span" translatable={false} fontSize={16}>
                                    <Trans
                                        i18nKey="finalPaymentGateway"
                                        components={{
                                            Text: <Text elementType="span" className="text-[12px]"/>,
                                        }}
                                    />
                                </Text>
                                <div>
                                    <Text elementType="span" translatable={false} fontSize={15}
                                          fontWeight={600}>{Number(Math.floor(Number(finalPayment ?? 0))).toLocaleString("en-US")}</Text>
                                    <Text elementType="span" className="ms-1" fontSize={12}>toman</Text>
                                </div>
                            </div>
                        </>
                        : null
                }
                <Button
                    title="pay"
                    className="w-full h-[40px] mt-[25px] mb-[6px]"
                    textClassName="text-sm"
                    loading={postExtraTokenShowLoading}
                    bg="primary"
                    onClick={buyToken}
                />
            </HasLoading>
        </Modal>
    );
};